import { ExternalMark, externalLinkProps } from "@softmax/web-ux/shell";
import type { ProfileSettingsData } from "../../account.types";
import { sectionLabel, linkStyle } from "./profile-styles";
import { LinkedAccount } from "./linked-account";

export function ProfileDiscord({
  discord,
}: Pick<ProfileSettingsData, "discord">) {
  if (discord.linkedUserId === null) return null;

  return (
    <div className="flex flex-col gap-[48px] pb-[48px] md:flex-row md:gap-[64px]">
      <section
        aria-labelledby="account-social"
        className="flex flex-1 flex-col gap-[24px] border-t border-[rgba(22,22,22,0.13)] pt-[24px]"
      >
        <h2 id="account-social" className={sectionLabel}>
          Social links
        </h2>
        <LinkedAccount
          title="Discord"
          action={null}
          body={
            <a
              href={`https://discord.com/users/${discord.linkedUserId}`}
              className={linkStyle}
              {...externalLinkProps}
            >
              Discord account linked
              <ExternalMark />
            </a>
          }
        />
        <p className="font-plex-sans text-[12px] leading-[15.6px] text-[#7c7c7c]">
          Discord is not used to sign in. To change it, ask the Softmax team in
          Discord.
        </p>
      </section>
    </div>
  );
}
